module.exports = __webpack_public_path__ + "static/media/dynamic-logo.870034b7.jpg";